export default __webpack_public_path__ + "static/media/saca.458f60a2.svg";